import _ from 'lodash';
import {
  BrowserEngine, RunOutSolver, AccountType, MemberType, defaultConfiguration,
} from 'super-engine';
import { Constants } from './constants';

export const engine = new BrowserEngine();
engine.setDefaults(_.defaultsDeep(require('./engine/config/client'), defaultConfiguration));
// console.log(55, engine); // see what the engine input object contains
/* eslint-disable no-param-reassign */
function preparePerson(state, modifier = Constants.PARAMETER_SUBJECT_SUFFIX) {
  //
  if (
    state.inputs[`AccountType${modifier}`].value === AccountType.ACCUMULATION
    && state.inputs[`MemberType${modifier}`].value === MemberType.QSUPER_NON_GOVERNMENT
  ) {
    state.inputs[`AccruedDBMultiple${modifier}`].value = 0;
    state.inputs[`DBMemberCoreContributionRate${modifier}`].value = 0;
    state.inputs[`EmployerContributionRate${modifier}`].value = state.inferred[`EmployerContributionRate${modifier}`].value;
    state.inputs[`AccumulationMemberCoreContributionRate${modifier}`].value = 0;
  //
  } else if (
    state.inputs[`AccountType${modifier}`].value === AccountType.ACCUMULATION
  ) {
    state.inputs[`AccruedDBMultiple${modifier}`].value = 0;
    state.inputs[`DBMemberCoreContributionRate${modifier}`].value = 0;
    state.inputs[`EmployerContributionRate${modifier}`].value = state.inferred[`EmployerContributionRate${modifier}`].value;
    state.inputs[`AccumulationMemberCoreContributionRate${modifier}`].value = state.inferred[`QSuperAccumulationMemberContributionRate${modifier}`].value;

    if (state.inputs[`Working${modifier}`].value === false) {
      state.inputs[`AccumulationMemberCoreContributionRate${modifier}`].value = 0;
      state.inputs[`EmployerContributionRate${modifier}`].value = 0;
    }
  //
  } else if (
    state.inputs[`AccountType${modifier}`].value === AccountType.DEFINED_BENEFIT
  ) {
    state.inputs[`AccruedDBMultiple${modifier}`].value = state.inferred[`AccruedDBMultiple${modifier}`].value;
    state.inputs[`DBMemberCoreContributionRate${modifier}`].value = state.inferred[`DBContributionRate${modifier}`].value;
    state.inputs[`EmployerContributionRate${modifier}`].value = 0;
    state.inputs[`AccumulationMemberCoreContributionRate${modifier}`].value = 0;
  }
}
/* eslint-enable */

function beforeRunEngine(state) {
  preparePerson(state);
  preparePerson(state, Constants.PARAMETER_PARTNER_SUFFIX);
  return state;
}

export default function runEngine(state) {
  const inputs = _.mapValues(beforeRunEngine(state).inputs, obj => obj.value);
  // console.log(54, inputs); // see what the engine input object contains
  // console.log(55, inputs, engine); // see what the engine input object contains
  const solved = RunOutSolver.setTargetIncomeForRunOut(engine, inputs, inputs.RunOutAge);
  inputs.TargetIncome = solved.targetIncome;
  return _.defaultsDeep(engine.runSync(inputs), solved);
}
